import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';

interface RTextButtonProps {
    onClick?: () => void;
    disabled?: boolean;
    type?: 'button' | 'submit';
    color?: string;
    size?: number;
    children: React.ReactNode;
}

export function RTextButton({ onClick, disabled, type = 'button', color, size, children }: RTextButtonProps) {
    return (
        <StyledTextButton type={type} onClick={onClick} disabled={disabled} color={color} size={size}>
            {children}
        </StyledTextButton>
    );
}

const StyledTextButton = styled('button')<{ color?: string; size?: number }>(({ color, size }) => ({
    background: 'none',
    border: 'none',
    padding: 0,
    color: color || Colors.darkNavy,
    fontSize: size || 14,
    fontWeight: 600,
    textDecoration: 'underline',
    cursor: 'pointer',
    '&:disabled': {
        opacity: 0.6,
        cursor: 'not-allowed',
    },
    outline: 'none',
    '&:focus, &:focus-visible': {
        outline: 'none',
        boxShadow: 'none',
        color: Colors.mediumGrey,
    },
}));
